import { HashRouter, Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthGate } from './components/AuthGate.js';
import { BottomTabBar } from './components/BottomTabBar.js';
import { IconBell, IconSettings } from './components/Icons.js';
import { StudioPage } from './pages/StudioPage.js';
import { StoryboardPage } from './pages/StoryboardPage.js';
import { JobsPage } from './pages/JobsPage.js';
import { JobDetailPage } from './pages/JobDetailPage.js';
import { SettingsPage } from './pages/SettingsPage.js';

function Header() {
  const navigate  = useNavigate();
  const location  = useLocation();

  // Judul dinamis berdasarkan rute aktif
  const title = (() => {
    const p = location.pathname;
    if (p.startsWith('/settings'))                  return 'Pengaturan';
    if (p.startsWith('/storyboard'))                return 'Storyboard';
    if (p === '/jobs')                              return 'Jobs';
    if (p.startsWith('/jobs/'))                     return 'Detail Job';
    return 'Studio';
  })();

  return (
    <header className="app-header">
      <h1>{title}</h1>
      <div className="app-header__actions">
        <button
          className="app-header__icon-btn tap-target"
          onClick={() => navigate('/jobs')}
          aria-label="Riwayat jobs"
        >
          <IconBell size={20} />
        </button>
        <Link to="/settings" className="app-header__icon-btn tap-target" aria-label="Pengaturan">
          <IconSettings size={20} />
        </Link>
      </div>
    </header>
  );
}

export function App() {
  return (
    <AuthGate>
      <HashRouter>
        <div className="app-shell">
          <Header />
          <main className="app-main">
            <Routes>
              <Route path="/"                         element={<StudioPage />} />
              <Route path="/storyboard"               element={<StoryboardPage />} />
              <Route path="/storyboard/:storyboardId" element={<StoryboardPage />} />
              <Route path="/jobs"                     element={<JobsPage />} />
              <Route path="/jobs/:id"                 element={<JobDetailPage />} />
              <Route path="/settings"                 element={<SettingsPage />} />
            </Routes>
          </main>
          <BottomTabBar />
        </div>
      </HashRouter>
    </AuthGate>
  );
}
